export default __webpack_public_path__ + "static/media/rtr-160-4v.22c98bc4.svg";